import { AppUI } from '@seedlang/state';
import autobind from 'autobind-decorator';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import Spinner from 'components/spinner';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import ButtonPrimary from 'components/button/button_primary';

@observer
class RssImport extends React.Component {
  @observable showSpinner = false;
  @observable rssUrl = '';
  @observable membershipTypeIds = [];
  @observable isSuccess = false;
  @observable errorMessage = null;

  constructor(props) {
    super(props);
    AppUI.membershipTypeStore.getIndex({});
  }

  toggleMembershipType(id) {
    if (this.isMembershipTypeChecked(id)) {
      this.uncheckMembershipType(id);
    } else {
      this.checkMembershipType(id);
    }
  }

  @action checkMembershipType(id) {
    this.membershipTypeIds.push(id);
  }

  @action uncheckMembershipType(id) {
    this.membershipTypeIds = this.membershipTypeIds.filter(i => i !== id);
  }

  isMembershipTypeChecked(id) {
    return this.membershipTypeIds.includes(id);
  }

  @autobind onImportRssFeed() {
    this.showSpinner = true;

    AppUI.podcastStore.importRssFeed({
      ids: {
        podcastId: this.props.podcastId,
      },
      data: {
        rssUrl: this.rssUrl,
        membershipTypeIds: this.membershipTypeIds,
      },
      failureCallback: error => {
        this.errorMessage = error.message;
        this.showSpinner = false;
      },
    }, this.afterImport);
  }

  @autobind afterImport() {
    this.showSpinner = false;
    this.isSuccess = true;
    this.props.afterImport();
  }

  @autobind onClear() {
    this.rssUrl = '';
    this.membershipTypeIds = [];
    this.isSuccess = false;
    this.errorMessage = null;
  }

  render() {
    return (
      <fieldset>
        <legend>Import RSS Feed</legend>

        {
          this.showSpinner ? (
            <Spinner />
          ) :
          this.isSuccess ? (
            <>
              <p>The RSS feeds is being imported in the background.</p>
              <ButtonPrimary onClick={this.onClear}>Clear</ButtonPrimary>
            </>
          ) :
          this.errorMessage ? (
            <>
              <p>{this.errorMessage}</p>
              <ButtonPrimary onClick={this.onClear}>Clear</ButtonPrimary>
            </>
          ) :
          (
            <>
              <input
                type='url'
                placeholder='https://example.com/feed.rss'
                value={this.rssUrl}
                onChange={e => this.rssUrl = e.target.value}
              />

              <ButtonPrimary onClick={this.onImportRssFeed}>Import</ButtonPrimary>
            </>
          )
        }

      </fieldset>
    );
  }
}

export default ErrorBoundary(RssImport);
